module.exports = __webpack_public_path__ + "img/logo.17522de5.svg";